import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import "./Accordion.css";

const AccordionWrapper = ({ data }) => {
  return (
    <Accordion allowZeroExpanded={true} id="accordion">
      {data.map(element => (
        <AccordionItem key={element.title}>
          <AccordionItemHeading>
            <AccordionItemButton>{element.title}</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <p>{element.description}</p>
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default AccordionWrapper;
